import styled, { css } from 'styled-components';
import { IconContainer } from '../../../../icon';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { pickToken } from '../../../styles/helper';
import { overrideCoreUIStyles, stateStyles } from './common.styled';
const RADIO_BOX_SIZE = 24;
const RADIO_HITBOX_OFFSET_HORIZONTAL = 6;
const RADIO_HITBOX_OFFSET_VERTICAL = 10;
const RADIO_SELECTED_SIZE = 8;
export const radioBasicStyles = ({ theme, $colorContext, }) => css `
	${overrideCoreUIStyles};

	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: none;
	height: ${pxToRem(RADIO_BOX_SIZE)};
	width: ${pxToRem(RADIO_BOX_SIZE)};
	background-color: ${theme.colors.blanc.bgFormField};
	border: ${pxToRem(theme.borderWidth['2'])} solid
		${pickToken({
    'on-light': theme.colors.medium.borderFormField,
    'on-medium': theme.colors.medium.borderFormField,
    'on-dark': theme.colors.blanc.bgFormField,
}, $colorContext)};
	border-radius: ${pxToRem(theme.borderRadius.rounded)};
	color: ${theme.colors.blanc.bgFormField};

	/* increased hitbox */
	&::after {
		content: '';
		position: absolute;
		top: -${pxToRem(RADIO_HITBOX_OFFSET_VERTICAL)};
		left: -${pxToRem(RADIO_HITBOX_OFFSET_HORIZONTAL)};
		width: calc(${pxToRem(RADIO_BOX_SIZE)} + (2 * ${pxToRem(RADIO_HITBOX_OFFSET_HORIZONTAL)}));
		height: calc(${pxToRem(RADIO_BOX_SIZE)} + (2 * ${pxToRem(RADIO_HITBOX_OFFSET_VERTICAL)}));
	}

	/* override overrideCoreUIStyles (before was "reset") */
	&&& {
		&::before {
			content: '';
			width: ${RADIO_SELECTED_SIZE}px;
			height: ${RADIO_SELECTED_SIZE}px;
			border-radius: ${theme.borderRadius.rounded}%;
			transition: background-color ${theme.timing['100']}ms cubic-bezier(${theme.easings.guide});
		}
	}

	${IconContainer} {
		margin: ${pxToRem(theme.borderWidth['2'])};
	}

	/* trigger pipeline */
	${stateStyles({
    default: {
        defaultHover: css `
				border-color: ${pickToken({
            'on-light': theme.colors.highlight.borderFormFieldHover,
            'on-medium': theme.colors.highlight.borderFormFieldHover,
            'on-dark': theme.colors.highlight.borderFormFieldOnDarkHover,
        }, $colorContext)};
				border-width: ${theme.borderWidth.m}px;
				transition: border-width ${theme.timing['100']}ms cubic-bezier(${theme.easings.guide});
			`,
        defaultChecked: css `
				background-color: ${pickToken({
            'on-light': theme.colors.highlight.bgRadiocheckboxSelected,
            'on-medium': theme.colors.highlight.bgRadiocheckboxSelected,
            'on-dark': theme.colors.highlight.bgRadiocheckboxSelectedOnDark,
        }, $colorContext)};
				border: none;
				transition: background-color ${theme.timing['100']}ms cubic-bezier(${theme.easings.guide});

				&::before {
					background-color: ${theme.colors.blanc.bgFormField};
				}
			`,
        defaultHoverChecked: css `
				background-color: ${pickToken({
            'on-light': theme.colors.highlight.bgRadiocheckboxSelectedHover,
            'on-medium': theme.colors.highlight.bgRadiocheckboxSelectedHover,
            'on-dark': theme.colors.highlight.bgRadiocheckboxSelectedHoverOnDark,
        }, $colorContext)};
			`,
    },
    error: {
        errorBase: css `
				border-color: ${pickToken({
            'on-light': theme.colors.error.borderFormField,
            'on-medium': theme.colors.error.borderFormField,
            'on-dark': theme.colors.error.borderFormFieldOnDark,
        }, $colorContext)};
			`,
        errorHover: css `
				border-width: ${theme.borderWidth.m}px;
				transition: border-width ${theme.timing['100']}ms cubic-bezier(${theme.easings.guide});
			`,
        errorChecked: css `
				background-color: ${theme.colors.blanc.bgFormField};
				transition: background-color ${theme.timing['100']}ms cubic-bezier(${theme.easings.guide});

				&::before {
					background-color: ${theme.colors.error.borderFormField};
				}
			`,
    },
    disabled: {
        disabledBase: css `
				background-color: ${pickToken({
            'on-light': theme.colors.light.bgRadiocheckboxDisabled,
            'on-medium': theme.colors.medium.bgRadiocheckboxDisabled,
            'on-dark': theme.colors.light.bgRadiocheckboxDisabled,
        }, $colorContext)};
				border: none;
				cursor: not-allowed;
			`,
        disabledChecked: css `
				background-color: ${pickToken({
            'on-light': theme.colors.light.bgRadiocheckboxDisabled,
            'on-medium': theme.colors.medium.bgRadiocheckboxDisabled,
            'on-dark': theme.colors.light.bgRadiocheckboxDisabled,
        }, $colorContext)};
				border: none;
				cursor: not-allowed;

				&::before {
					background-color: ${pickToken({
            'on-light': theme.colors.medium.bgRadiocheckboxDisabled,
            'on-medium': theme.colors.light.bgRadiocheckboxDisabled,
            'on-dark': theme.colors.medium.bgRadiocheckboxDisabled,
        }, $colorContext)};
				}
			`,
    },
    focus: css `
			outline: ${theme.borderWidth.m}px solid
				${pickToken({
        'on-light': theme.colors.highlight.borderFocus,
        'on-medium': theme.colors.highlight.borderFocus,
        'on-dark': theme.colors.highlight.borderFormFieldOnDarkFocus,
    }, $colorContext)};
			outline-offset: ${theme.borderWidth.m}px;
		`,
})}
`;
export const RadioBasic = styled.span `
	${radioBasicStyles}
`;
